import React, { useState } from "react";

const UserSignUp = () => {
  const [activeTab, setActiveTab] = useState("mobile");
  return (
    <>
      <section className="auth-page-bg py-8 md:py-24 relative">
        <div className="container">
          <div className="flex items-center justify-center">
            <div className="max-w-[485px] w-full text-center">
              {/* Title and Subtitle */}
              <h1 className="web-h2 text-gray-950 mb-2">Create Your Account</h1>
              <p className="text-gray-600 web-body-sm mb-8">
                Register now and unlock astrology insights.
              </p>

              {/* Login Card Container */}
              <div className="bg-white p-[15px] md:p-[20px] rounded-[20px] shadow-[0px_1px_14px_rgba(79,77,77,0.08)]">
                {/* Tabs Navigation */}
                <div className="flex border-b border-gray-200 mb-6">
                  <button
                    className={`py-3 w-1/2 !pt-0 text-[14px] medium transition-colors duration-200 ${
                      activeTab === "mobile"
                        ? "text-[#020079] border-b-2 border-[#020079]"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                    onClick={() => setActiveTab("mobile")}
                  >
                    Sign up with Mobile
                  </button>
                  <button
                    className={`py-3 w-1/2 !pt-0 medium text-[14px] transition-colors duration-200 ${
                      activeTab === "email"
                        ? "text-[#020079] border-b-2 border-[#020079]"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                    onClick={() => setActiveTab("email")}
                  >
                    Sign up with Email
                  </button>
                </div>

                {/* Form Content */}
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="flex flex-col gap-[15px] text-left"
                >
                  {activeTab === "mobile" && (
                    <>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="name"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          id="name"
                          className="custom-input"
                          placeholder="Enter Name"
                          required
                        />
                      </div>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="mobile"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Mobile
                        </label>
                        <input
                          type="tel"
                          id="mobile"
                          className="custom-input"
                          placeholder="Enter mobile"
                          required
                        />
                      </div>
                    </>
                  )}

                  {activeTab === "email" && (
                    // This is a placeholder for the email form state
                    <>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="name"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Name
                        </label>
                        <input
                          type="email"
                          id="email"
                          className="custom-input"
                          placeholder="Enter Name"
                          required
                        />
                      </div>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="email"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          id="email"
                          className="custom-input"
                          placeholder="Enter email"
                          required
                        />
                      </div>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="name"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          id="Password"
                          className="custom-input"
                          placeholder="Enter Password"
                          required
                        />
                      </div>
                      <div className="flex flex-col gap-[8px]">
                        <label
                          htmlFor="name"
                          className="text-[15px] text-gray-950 semibold"
                        >
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          id="Password"
                          className="custom-input"
                          placeholder="Enter Password"
                          required
                        />
                      </div>
                    </>
                  )}

                  {/* Log In Button (Matches the golden/yellow color) */}
                  <button
                    type="submit"
                    className="custom-btn custom-btn-primary w-full mt-[15px]"
                    onClick={() =>
                      document.getElementById("loginModal").showModal()
                    }
                  >
                    Sign Up
                  </button>
                </form>

                {/* Sign Up Link */}
                <p className="mt-6 web-body-md text-gray-600 flex items-center gap-[5px] justify-center">
                  Already have an account?
                  <a href="#" className="text-link">
                    Log In
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 hidden xl:block">
          <img src="/images/shape3.png" alt="shape" />
        </div>
        <div className="absolute bottom-0 right-0 hidden xl:block">
          <img src="/images/shape4.png" alt="shape" />
        </div>
      </section>

      <dialog id="loginModal" className="modal">
        <div className="modal-box p-0">
          <form method="dialog">
            <div className="modal-header flex items-start gap-[10px] justify-between border-0 mb-[15px]">
              <div className="modal-head-left flex flex-col gap-[5px]">
                <h3 className="web-h5 semibold">Phone Verification</h3>
                <p className="web-body-md">
                  We’ve sent a OTP to your number for secure access.
                </p>
              </div>
              <button className="">
                <img src="/images/close.svg" alt="close" />
              </button>
            </div>
          </form>

          <div className="modal-body pt-0">
            <div className="otp-box flex items-center gap-[10px]">
              <input type="text" className="custom-input" />
              <input type="text" className="custom-input" />
              <input type="text" className="custom-input" />
              <input type="text" className="custom-input" />
            </div>
          </div>

          <div className="modal-footer border-gray-100 flex items-center !justify-between">
            <p className="web-body-md text-gray-600 w-auto">
              Didn’t receive OTP? <a className="text-link">Resend</a>
            </p>
            <div className="flex items-center gap-[10px]">
              <button className="custom-btn custom-btn-secondary">
                Cancel
              </button>
              <button className="custom-btn custom-btn-primary">
                Continue
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default UserSignUp;
